import { RequestType } from '../types/Request.type'
import { HistoryItemType, ImagesKeys, InfoType } from '../types/store.types'

export const mapImagesKeys: Record<ImagesKeys, string> = {
  installImages: 'Установка оборудования',
  impossibleImages: 'Установка невозможна',
  uncompletedImages: 'На доработку',
  clarificationImages: 'Уточнение данных',
  reportedEditImages: 'Установка другому Абоненту',
}

export const informationKeys: Partial<keyof RequestType>[] = [
  'name',
  'phone',
  'address',
  'categories',
]

export const requestVisibleInformationKeys: Partial<keyof RequestType>[] = [
  'hasDuplicates',
  'isSuspicious',
  'isDangerous',
  'created',
]

export const requestInformationKeys: Partial<keyof RequestType>[] = [
  'source',
  'authorId',
  'sender',
  'reason',
  'additionalInfo',
]

export const historyItemProperties: Array<
  keyof HistoryItemType | keyof InfoType
> = [
  'info',
  'createDate',
  'installationDate',
  'equipmentId',
  'photos',
  'reportNumber',
  'serialNumber',
  'Surname',
  'Name',
  'Patronymic',
  'Phone',
  'Territory',
  'District',
  'Locality',
  'AddressType',
  'Address',
  'House',
  'Building',
  'Apartment',
  'Reason',
  'PreferentialCategory',
  'AdditionalInfo',
  'EquipmentId',
  'SenderId',
  'Installed',
  'installed',
  'Categories',
  'www',
  'reasonId',
  'financialSource',
  'dealer',
]

export const dataEditStatuses = [1, 2, 4, 5, 7, 9, 10, 11]
export const infoEditStatuses = [1, 2, 4, 5, 7, 9, 10, 11]
export const dataEditReportStatuses = [4, 102, 200]
export const getCanAddPicsAA = (request: RequestType) =>
  request.status === 15 && request.reportStatus === 4
